export default __webpack_public_path__ + "static/media/hht1_ep13_timeline_q01_a.783902c7.png";